import { apiClient } from '../shared/api-client';
import { isMockTestEmail } from '../shared/mock-test-user';

function validateEmail(email) {
    if (!email.trim()) {
        return {
            isValid: false,
            code: 'emptyEmail',
            message: 'Please enter your email address'
        };
    }

    const isValidEmail = String(email)
        .toLowerCase()
        .match(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);

    if (!isValidEmail) {
        return {
            isValid: false,
            code: 'invalidEmail',
            message: 'Please enter a working email address and make sure it\'s typed correctly.'
        };
    }

    return {
        isValid: true,
        message: ''
    };
}

async function asyncValidateEmail(email) {
    if (isMockTestEmail(email)) {
        return {
            isValid: true,
            message: ''
        };
    }

    try {
        await apiClient.post({
            url: 'auth/email/validate',
            body: { email }
        });

        return {
            isValid: true,
            message: ''
        };
    } catch (error) {
        if (error?.response?.didYouMean) {
            return {
                isValid: false,
                code: 'didYouMean',
                message: `Did you mean ${error.response.didYouMean}?`,
                data: {
                    didYouMean: error.response.didYouMean
                }
            };
        }

        return {
            isValid: false,
            code: error?.code || 'invalidEmail',
            message: 'Please enter a working email address and make sure it\'s typed correctly.'
        };
    }
}

export {
    validateEmail,
    asyncValidateEmail
};
